import { useApiQueries } from '../../app/ApiClientContext';
import { Skeleton } from '../../components/Skeleton';
import { ActivityChart } from './ActivityChart';

export function LinkActivityPanel({ linkId }: { linkId: number }) {
  const $api = useApiQueries();
  const q = $api.useQuery('get', '/api/v2/link/{link_id}', {
    params: { path: { link_id: linkId } },
  });

  if (q.isLoading) {
    return (
      <div className="space-y-4 pt-3">
        <Skeleton className="h-40 w-full" />
        <Skeleton className="h-40 w-full" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }
  if (q.isError || !q.data) {
    return (
      <p className="text-sm text-[var(--color-text-muted)] pt-3">
        Не удалось загрузить статистику.
      </p>
    );
  }
  const d = q.data;
  return (
    <div className="pt-3 space-y-4">
      <section>
        <h4 className="text-xs uppercase tracking-wide text-[var(--color-text-muted)] mb-1">
          За всё время · {d.total_redirects} переходов
        </h4>
        <ActivityChart buckets={d.all_time} granularity={d.all_time_granularity} />
      </section>
      <section>
        <h4 className="text-xs uppercase tracking-wide text-[var(--color-text-muted)] mb-1">
          Последний месяц (по дням)
        </h4>
        <ActivityChart buckets={d.last_month} granularity="day" />
      </section>
      <section>
        <h4 className="text-xs uppercase tracking-wide text-[var(--color-text-muted)] mb-1">
          Последние 24 часа (по часам)
        </h4>
        <ActivityChart buckets={d.last_day} granularity="hour" />
      </section>
    </div>
  );
}
